// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { ContactRelationshipsState } from '../_reducers/contact-relationship.reducers';
import { ContactRelationshipModel } from '../_models/contact-relationship.model';

export const selectContactRelationshipsState =
  createFeatureSelector<ContactRelationshipsState>('contactRelationships');

export const selectContactRelationshipById = (contactRelationshipId: number) =>
  createSelector(selectContactRelationshipsState, (contactRelationshipsState) => {
    return contactRelationshipsState.entities[contactRelationshipId];
  });

export const selectContactRelationshipsPageLoading = createSelector(
  selectContactRelationshipsState,
  (contactRelationshipsState) => contactRelationshipsState.loading,
);

export const selectCurrentContactIdInStoreForContactRelationships = createSelector(
  selectContactRelationshipsState,
  (contactRelationshipsState) => contactRelationshipsState.contactId,
);

export const selectLastCreatedContactRelationshipId = createSelector(
  selectContactRelationshipsState,
  (contactRelationshipsState) => contactRelationshipsState.lastCreatedContactRelationshipId,
);

export const selectCRShowInitWaitingMessage = createSelector(
  selectContactRelationshipsState,
  (contactRelationshipsState) => contactRelationshipsState.showInitWaitingMessage,
);

export const selectContactRelationshipsActionLoading = createSelector(
  selectContactRelationshipsState,
  (contactRelationshipsState) => contactRelationshipsState.actionsloading,
);

export const selectContactRelationshipErrorState = createSelector(
  selectContactRelationshipsState,
  // tslint:disable-next-line:max-line-length
  (contactRelationshipsState) => contactRelationshipsState.error,
);

export const selectContactRelationshipLatestSuccessfullAction = createSelector(
  selectContactRelationshipsState,
  (contactRelationshipsState) => contactRelationshipsState.latestSuccessfullAction,
);

export const selectContactRelationshipsPageLastQuery = createSelector(
  selectContactRelationshipsState,
  (contactRelationshipsState) => contactRelationshipsState.lastQuery,
);
export const selectContactRelationshipsInStore = createSelector(
  selectContactRelationshipsState,
  (contactRelationshipsState) => {
    const items: ContactRelationshipModel[] = [];
    each(contactRelationshipsState.ids, (ele) => {
      const index: number = +ele;
      items.push(contactRelationshipsState.entities[index]);
    });
    return new QueryResultsModel(items, contactRelationshipsState.totalCount);
  },
);
